import { HubListSearchCriteria } from '../models';

export class HubListLoad {
  public static readonly type = '[HubList] Load';
  constructor(public payload: HubListSearchCriteria) {}
}

export class HubListInitialState {
  public static readonly type = '[HubList] Set initial state';
}
